import { useContext } from "react";
import { Link } from "react-router-dom";

import { Badge, Modal } from "flowbite-react";

import { IAppContextState, AppContext } from "../../../App";
import { NexoImageGallery } from "../../../components/image-gallery/nexo-gallery";

export const NexoModalData = () => {
  const { nexoModalState } = useContext<IAppContextState | any>(AppContext);
  const [isOpenNexoModal, setOpenNexoModal] = nexoModalState;
  return (
    <Modal
      size={"5xl"}
      position={"top-center"}
      show={isOpenNexoModal}
      onClose={() => setOpenNexoModal(false)}
    >
      <Modal.Header>Nexo Pet Care</Modal.Header>
      <Modal.Body>
        <div className="flex flex-wrap">
          <div className="md:w-[50%] w-full pe-2">
            <NexoImageGallery />
          </div>
          <div className="md:w-[50%] w-full ps-2 md:mt-0 mt-6 flex flex-col justify-between">
            <div>
              <h3 className="font-bold text-xl">
                Project name: <span className="text-pink-500">Nexo</span>
              </h3>
              <p className="mt-4 mb-2 text-md text-[15px]">Tech used:</p>
              <div className="flex">
                <Badge color="cyan" className="me-2 my-1">
                  React
                </Badge>
                <Badge color="blue" className="me-2 my-1">
                  Bootstrap
                </Badge>
                <Badge color="pink" className="my-1">
                  SCSS
                </Badge>
              </div>
              <div className="mt-5 mb-2 ">
                <p className="font-semibold">Description:</p>
                <div className="text-[15px]">
                  <p>
                    NEXO Pet Care is a platform offering a range of pet care
                    services and products. It provides a smooth and engaging
                    experience for pet owners to explore, book services, and
                    shop products. Any user can easily communicate with expert
                    vet doctors through this app.
                  </p>
                  <ul className="list-disc mt-4 ms-5">
                    <li>
                      In NEXO, Browse and book various pet care services and
                      shop quality pet products.
                    </li>
                    <li>Visually appealing and mobile-friendly interface.</li>
                    <li>
                      Easy navigation, service/product search, and seamless
                      browsing for pet owners.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="mt-10">
              <Link
                target="_blank"
                rel="noreferrer"
                to="https://www.nexopet.com/"
                className="text-pink-500 hover:text-pink-600 hover:underline"
              >
                Go to website
              </Link>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
